import React, { useCallback, useMemo, useState } from "react";

import { NavigationContext } from "./NavigationContext";

export const NavigationProvider: React.FC<React.PropsWithChildren<unknown>> = (props) => {
    const [isNavigationOpen, setIsNavigationOpen] = useState(true);

    const toggleNavigation = useCallback(() => {
        setIsNavigationOpen((prev) => !prev);
    }, []);

    const value = useMemo(() => ({ isNavigationOpen, toggleNavigation }), [isNavigationOpen, toggleNavigation]);

    return <NavigationContext.Provider value={value}>{props.children}</NavigationContext.Provider>;
};
